// Deploy builds set REACT_APP_API_ENDPOINT from SSM (scripts/build-for-env.sh).
// These URLs are only fallbacks for local runs.
const dev = {
  API_ENDPOINT: "https://8kxzmynoae.execute-api.us-east-1.amazonaws.com",
  SITE_URL: "https://site.dev.cochranskisale.com"
};

const prod = {
  API_ENDPOINT: "https://iypj3vpe38.execute-api.us-east-1.amazonaws.com",
  // site.prod works before and after the cochranskisale.com cutover
  SITE_URL: "https://site.prod.cochranskisale.com"
};

const config = process.env.REACT_APP_ENV === 'prod'
  ? prod
  : dev;

const endpointOverride = process.env.REACT_APP_API_ENDPOINT;
const siteOverride = process.env.REACT_APP_SITE_URL;

export default {
  IMAGE_UPLOAD_SUPPORT: false,
  ...config,
  ...(endpointOverride ? { API_ENDPOINT: endpointOverride } : {}),
  ...(siteOverride ? { SITE_URL: siteOverride } : {})
};